import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from './AuthProvider.jsx'

// Usage:
//   <Route element={<RequireRole roles={['doctor','specialist']} />}>
//     <Route path="/doctor" ... />
//   </Route>
//
// On a denial, navigates to /unauthorized with the allowed-roles list
// in `state` so the Unauthorized page can name exactly who the page
// is restricted to (e.g. "This page is restricted to platform
// administrators only").
export default function RequireRole({ roles = [] }) {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  const role = (user.role || '').toLowerCase()
  const allowed = roles.map((r) => r.toLowerCase())
  if (allowed.length > 0 && !allowed.includes(role)) {
    return (
      <Navigate
        to="/unauthorized"
        replace
        state={{ allowed }}
      />
    )
  }
  return <Outlet />
}
